import { StandardsLoadingSpinner } from "./StandardsLoadingSpinner";

export { StandardsLoadingSpinner };
